import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() userName: string = '';
  @Input() message: string = 'YOU HAVE NO ORDERS AT THE MOMENT';
  @Input() buttonText: string = 'Buy Hardware';
  @Input() buttonAction: () => void = () => {};
  @Input() showButton: boolean = true;

  onButtonClick(): void {
    if (this.buttonAction) {
      this.buttonAction();
    }
  }
}
